// extracted by mini-css-extract-plugin
export default {"dropdownsSection":"dropdownsSection-drCKq","label":"label-xoOHK","button":"button-N7gtD","addBtn":"addBtn-U3jzU","addIcon":"addIcon-DT2K2"};